export default "__VITE_ASSET__61d5f9fd__"